export enum TextStyleOptions {
  BOLD = 'bold',
  ITALIC = 'italic',
  UNDERLINE = 'underline',
  STRIKE_THROUGH = 'strike_through',
}
